export const getStaticFileUrl = (...relativePath) => {
    return [process.env.REACT_BUNDLE_URL, ...relativePath].join("/");
};
